import React from 'react';
import styled from 'styled-components';

import { Bubble, HintButton } from '@lt/components';
import type {
  Placement,
  BubbleEventType,
  BubbleWidth,
} from '@lt/components/components/Bubble';

interface IBubbleFilter {
  placement?: Placement;
  eventType?: BubbleEventType;
  width?: BubbleWidth;
  noWrap?: boolean;
  text: string;
}

const BubbleFilter: React.FC<IBubbleFilter> = ({
  placement = 'right',
  eventType = 'hover',
  width = 'min',
  noWrap = false,
  text = 'Hint text',
}) => (
  <StyledBubble
    eventType={eventType}
    placement={placement}
    closeable={false}
    width={width}
    noWrap={noWrap}
    inline
    text={text}
  >
    <HintButton className="lt-icons-hint" as="span" white />
  </StyledBubble>
);

const StyledBubble = styled(Bubble)`
  margin-inline-start: 3px;
`;

export default BubbleFilter;
